import config from '@/config'
import axios from 'axios'
const instance = axios.create({
  baseURL: `${config.getConfig('serverUrl')}`,
  timeout: 30000
})

export const pageApi = {
  getPageProfile: ({ pageId }) => {
    return instance.get(`/pageprofile?pageid=${pageId}`)
  }
}
